import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { AuthService } from 'app/auth/auth.service';
import { BillingserviceService } from 'app/billing/billingService.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { InvestigationServicesComponent } from 'app/EMR/Doctor/investigation-services/investigation-services.component';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { BranchMatserService } from 'app/masters/branch-matser.service';
import { masterPakageModel } from 'app/masters/models/service-master.model';
import { ExportService } from 'app/reports/services/export.service';
import { Observable, Subject } from 'rxjs';
import * as moment from 'moment';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { nlLocale } from 'ngx-bootstrap';
@Component({
  selector: 'app-package-master',
  templateUrl: './package-master.component.html',
  styleUrls: ['./package-master.component.scss']
})
export class PackageMasterComponent implements OnInit {
  destroypakage$: Subject<boolean> = new Subject<boolean>();
  private partylist: any = [];
  editCache: any = {};
  private filteredArray: any[] = [];
  private filteredserviceArray: any[] = [];
  private serviceList: any = [];
  private mainServiceTableData: any[] = [];
  pakageMasterModel: masterPakageModel = {};
  searchText: string = '';
  searchservicelist: string = '';
  private filteredSearchserviceArray: any = []
  private partyListArray: any = [];
  private addServicedata: any[] = [];
  private storesPackageDetails: any = [];
  private storePartyRelation: any = [];
  private partyList: any = [];
  pakageId: any
  enabledisablebtn: boolean = true;
  addWithoutClearField: boolean = false
  isAddCase: boolean = true;
  constructor(private ipdservice: IPDService,
    private billingservice: BillingserviceService,
    private branchmasterService: BranchMatserService,
    public authservice: AuthService,
    private dialog: MatDialog,
    private exportdata: ExportService,
    private datePipe: DatePipe,
    private dashboardService: DashboardService,) {
    this.pakageMasterModel.isGlobal = true;
    this.pakageMasterModel.packageAmount = 0;
    this.pakageMasterModel.isActive = false;
  }

  ngOnInit(): void {
    this.getpartyList();
    this.getSearchPackageMaster(this.searchvalue);
    this.pakageMasterModel.validFrom = new Date();
    this.pakageMasterModel.validupto = new Date();
  }
  enableButton() {
    if (!this.pakageMasterModel.packageName || this.pakageMasterModel.packageName.toString().trim() === '') {
      this.enabledisablebtn = true;
    } else {
      this.enabledisablebtn = false;
    }
  }

  getServiceList(pK_PackageId: number) {
    this.branchmasterService.getServiceList(pK_PackageId).pipe(takeUntil(this.destroypakage$)).subscribe((res) => {
      this.mainServiceTableData = res
      this.filteredserviceArray = this.serviceList.filter(item => item.isActive == true);
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  updateEditCache(): void {
    this.mainServiceTableData.forEach((item, index) => {
      this.editCache[index] = {
        edit: false,
        data: { ...item },
      };
    });
  }

  Edit(index: number, item: any) {
    // Object.keys(this.editCache).forEach((key) => {
    //   if (this.editCache[key]?.edit) {this.canceledit(parseInt(key), this.mainServiceTableData[key]);}
    //    });
    this.mainServiceTableData[index].rateGeneral = item.rateGeneral
    this.pakageMasterModel.packageAmount = Math.floor(this.mainServiceTableData[index].rateGeneral - (this.mainServiceTableData[index].rateGeneral * this.mainServiceTableData[index].discount / 100))
    this.calculateTempTotalAmount();
    this.updateEditCache();
    this.editCache[index].edit = true;
  }
  deleteArray = [];
  deleteItem(index: number, item: any) {
    if (item.pK_PackageDetailId && item.pK_PackageDetailId != 0) {
      //   this.storesPackageDetails.push({
      //     "pK_PackageDetailId": item.pK_PackageDetailId,
      //     "fK_PackageId": item.fK_PackageId,
      //     "fK_ServiceId": item.fK_ServiceId,
      //     "rateGeneral": item.rateGeneral,
      //     "rateSemiPrivate": item.rateSemiPrivate,
      //     "ratePrivate": item.ratePrivate,
      //     "rateSemiDelux": item.rateSemiDelux,
      //     "rateDelux": item.rateDelux,
      //     "discount": item.discount,
      //     "serviceCharge": item.serviceCharge,
      //     "isActive": item.isActive,
      //     "isEdit": item.pK_PackageDetailId ? true : false,
      //     "headName": item.headName ? item.headName : 'PACKAGEDETAIL',
      //     "deptName": item.deptName,
      //     "categoryName": item.categoryName,
      //     "serviceName": item.serviceName,
      //     "fk_DeptId": item.fk_DeptId,
      //     "fk_CategoryId": item.fk_CategoryId,
      //     "isSCApplicable": item.isSCApplicable,
      //     "maxDiscountLimit": item.maxDiscountLimit,
      //     "isDelete": item.pK_PackageDetailId ? true : false,
      //   })
      // }
      this.mainServiceTableData[index].isEdit = true;
      this.mainServiceTableData[index].isDelete = true;
      this.mainServiceTableData[index].headName = 'PACKAGEDETAIL'
      this.deleteArray.push(
        this.mainServiceTableData[index]
      )
    }
    this.mainServiceTableData.splice(index, 1);
    if (item.rateGeneral) {
      this.pakageMasterModel.packageAmount -= item.rateGeneral;
      this.calculateTempTotalAmount();
    }
  }

  saveedit(index: number, item: any) {
    if (item.discount > 100) {
      this.dashboardService.openSnackBar("Discount percentage cannot be greater than 100", "OK");
      return;
    }
    // if (item.pK_PackageDetailId && item.pK_PackageDetailId != 0) {
    //   this.storesPackageDetails.push({
    //     "pK_PackageDetailId": item.pK_PackageDetailId,
    //     "fK_PackageId": item.fK_PackageId,
    //     "fK_ServiceId": item.fK_ServiceId,
    //     "rateGeneral": item.rateGeneral,
    //     "rateSemiPrivate": item.rateSemiPrivate,
    //     "ratePrivate": item.ratePrivate,
    //     "rateSemiDelux": item.rateSemiDelux,
    //     "rateDelux": item.rateDelux,
    //     "discount": item.discount,
    //     "serviceCharge": item.serviceCharge,
    //     "isActive": item.isActive,
    //     "isEdit": item.pK_PackageDetailId ? true : false,
    //     "headName": item.headName ? item.headName : 'PACKAGEDETAIL', //without headname Api 500 error
    //     "deptName": item.deptName,
    //     "categoryName": item.categoryName,
    //     "serviceName": item.serviceName,
    //     "fk_DeptId": item.fk_DeptId,
    //     "fk_CategoryId": item.fk_CategoryId,
    //     "isSCApplicable": item.isSCApplicable,
    //     "maxDiscountLimit": item.maxDiscountLimit,
    //     "isDelete": false
    //   })
    // }
    this.editCache[index].edit = false;

  }

  canceledit(index: number, item: any) {
    this.mainServiceTableData[index] = { ...this.editCache[index].data };
    this.editCache[index].edit = false;
  }

  disablePastDates = (date: Date | null): boolean => {
    if (this.isAddCase) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date ? date >= today : false;
    }
    return true;
  };


  helpListPOpup(parameter, type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        parametertype: parameter
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroypakage$)).subscribe(result => {
      if (type == 1) {
        this.pakageMasterModel.packageGroup = result;
      } else if (type == 2) {
        this.pakageMasterModel.packageType = result;
      }
    });
  }

  searchserviceList: any = [];
  searchvalue: any
  // getSearchPackageMaster(event) {
  //   if (!event || event.trim() === "") {
  //     this.searchvalue = 0
  //   } else {
  //     if(event.length > 4){
  //       this.searchvalue = event;
  //     }
  //   }
  // this.branchmasterService.getSearchPackageMaster(0, this.searchvalue).pipe(takeUntil(this.destroypakage$)).subscribe((res) => {
  //   this.searchserviceList = res;
  // }, err => {
  //   if (err.status == 403) {
  //     this.dashboardService.openSnackBar("You Don't have Permission", "OK");
  //   }else if (err.error.statusCode == 422) {
  //     this.dashboardService.openSnackBar(err.error.message,"OK");
  //   }else {
  //     this.dashboardService.openSnackBar("API Failed", "OK");
  //   }
  // })
  // }
  getSearchPackageMaster(event) {
    if (!event || event.trim() === "") {
      this.searchvalue = 0;
      this.callSearchApi();
    } else {
      if (event.length >= 4) {
        this.searchvalue = event;
        this.callSearchApi();
      }
    }
  }

  callSearchApi() {
    this.branchmasterService.getSearchPackageMaster(0, this.searchvalue)
      .pipe(takeUntil(this.destroypakage$))
      .subscribe(
        (res) => {
          this.searchserviceList = res;
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }


  discountcalculation(index, item) {
    this.mainServiceTableData[index].discount = item
    this.pakageMasterModel.packageAmount = Math.floor(this.mainServiceTableData[index].rateGeneral - (this.mainServiceTableData[index].rateGeneral * this.mainServiceTableData[index].discount / 100))
    this.calculateTempTotalAmount();
  }


  calculatedisscount(index, value) {
    this.mainServiceTableData[index].rateGeneral = value
    this.pakageMasterModel.packageAmount = Math.floor(this.mainServiceTableData[index].rateGeneral - (this.mainServiceTableData[index].rateGeneral * this.mainServiceTableData[index].discount / 100))
    this.calculateTempTotalAmount();
  }

  calculateTempTotalAmount() {
    if (this.mainServiceTableData && this.mainServiceTableData.length > 0) {
      this.pakageMasterModel.packageAmount = Math.floor(this.mainServiceTableData.reduce((acc, item) => {
        const discountedAmount = item.rateGeneral - (item.rateGeneral * (item.discount || 0) / 100);
        return acc + (discountedAmount || 0);
      }, 0));
    } else {
      this.pakageMasterModel.packageAmount = 0;
    }
  }

  getPackagePartyRelation(PackageId: number) {
    this.branchmasterService.getPackagePartyRelation(PackageId).pipe(takeUntil(this.destroypakage$)).subscribe((res) => {
      this.partyList = res;
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  getpartyList() {
    this.ipdservice.get_partytpa().pipe(takeUntil(this.destroypakage$)).subscribe((res) => {
      this.partylist = res;
      this.filteredArray = res.map(item => {
        item.isSelected = this.partyList.some(party => party.fK_PartyId === item.pkPartyId);
        return item;
      });
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  filterTable() {
    this.filteredArray = this.partylist.filter((item) =>
      Object.keys(item)
        .map((key) => item[key])
        .join(' ')
        .toLowerCase()
        .includes(this.searchText.toLowerCase())
    );
  }


  populateForm(item: any) {
    this.pakageMasterModel.packageName = item.packageName;
    this.pakageMasterModel.pK_PackageId = item.pK_PackageId
    this.pakageMasterModel.validFrom = item.validFrom;
    this.pakageMasterModel.validupto = item.validupto;
    this.pakageMasterModel.packageCodeNo = item.packageCodeNo
    this.pakageMasterModel.packageAmount = item.packageAmount
    this.pakageMasterModel.isGlobal = item.isGlobal
    this.pakageMasterModel.isActive = item.isActive
    this.pakageMasterModel.packageGroup = item.packageGroup
    this.pakageMasterModel.packageType = item.packageType
    if (this.pakageMasterModel.pK_PackageId) {
      this.isAddCase = false;
    }
    this.getServiceList(item.pK_PackageId)
    this.enableButton();
    this.closePackageMasterSearchRecordModal();
    this.storePartyRelation = [];
    this.branchmasterService.getPackagePartyRelation(this.pakageMasterModel.pK_PackageId).pipe(takeUntil(this.destroypakage$)).subscribe((res) => {
      this.partyList = res;
      this.filteredArray = this.partylist.map(partyItem => {
        partyItem.isSelected = this.partyList.some(party => party.fK_PartyId === partyItem.pkPartyId);
        return partyItem;
      });
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });

  }

  updatePartySelection(item: any) {
    if (this.partyList.some(party => party.fK_PartyId == item.pkPartyId && party.pK_TranId > 0)) {
      this.partyList.forEach((party) => {
        // Check if the record already exists
        const existingRecordIndex = this.storePartyRelation.findIndex(
          rel => rel.fK_PartyId === item.pkPartyId
        );
        if (existingRecordIndex > -1) {
          // Update the existing record
          this.storePartyRelation[existingRecordIndex].isDelete = item.isSelected == false ? true : false;
        } else {
          // Add a new record only if it does not already exist
          this.storePartyRelation.push({
            "pK_TranId": party.pK_TranId ? party.pK_TranId : 0,
            "fK_PartyId": party.pK_TranId ? party.fK_PartyId : item.pkPartyId,
            "fK_PackageId": party.fK_PackageId ? party.fK_PackageId : 0,
            "packageName": this.pakageMasterModel.packageName,
            "partyName": party.partyName,
            "isEdit": party.pK_TranId ? true : false,
            "isDelete": item.isSelected == false ? true : false,
            "headName": 'PACKAGEPARTYRELATION' // without headname API gives 500 error
          });
        }
      });
    } else {
      if (item.isSelected) {
        this.storePartyRelation.push({
          "pK_TranId": item.pK_TranId ? item.pK_TranId : 0,
          "fK_PartyId": item.pK_TranId ? item.fK_PartyId : item.pkPartyId,
          "fK_PackageId": item.fK_PackageId ? item.fK_PackageId : 0,
          "packageName": this.pakageMasterModel.packageName,
          "partyName": item.partyName,
          "isEdit": item.pK_TranId ? true : false,
          "isDelete": false,
          "headName": 'PACKAGEPARTYRELATION' //without headname Api give 500 error
        })
      } else {
        this.storePartyRelation = this.storePartyRelation.filter(
          (record: any) => record.fK_PartyId !== (item.pK_TranId ? item.fK_PartyId : item.pkPartyId)
        );
      }
    }
  }


  savePackage(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 2000);


    const isInvalidDiscount = this.mainServiceTableData.some(item => item.discount > 100);
    if (isInvalidDiscount) {
      this.dashboardService.openSnackBar("Discount percentage cannot be greater than 100", "OK");
      return;
    }
    if (!this.pakageMasterModel.packageName) {
      this.dashboardService.openSnackBar("Please select Package Name", "OK");
      return;
    }
    if (!this.pakageMasterModel.validFrom) {
      this.dashboardService.openSnackBar("Please select the validFrom Date ", "OK");
      return;
    }
    if (!this.pakageMasterModel.validupto) {
      this.dashboardService.openSnackBar("Please select the validupto Date", "OK");
      return;
    }
    const validFromDate = new Date(this.pakageMasterModel.validFrom);
    const validUptoDate = new Date(this.pakageMasterModel.validupto);
    if (validFromDate > validUptoDate) {
      this.dashboardService.openSnackBar("Please select valid upto date. Valid upto date should be greater than valid from date.", "OK");
      return;
    }

    this.mainServiceTableData.forEach((item, index) => {
      if (this.editCache[index] && this.editCache[index].edit) {
        this.editCache[index].edit = false;
      }
    });

    const storepackageMaster = {
      "pK_PackageId": this.pakageMasterModel.pK_PackageId ? this.pakageMasterModel.pK_PackageId : 0,
      "packageName": this.pakageMasterModel.packageName,
      "packageCodeNo": this.pakageMasterModel.packageCodeNo,
      "packageAmount": this.pakageMasterModel.packageAmount,
      "isGlobal": this.pakageMasterModel.isGlobal,
      "validFrom": moment(this.pakageMasterModel.validFrom).format('YYYY-MM-DD'),
      "validupto": moment(this.pakageMasterModel.validupto).format('YYYY-MM-DD'),
      "isActive": this.pakageMasterModel.isActive,
      "isEdit": this.pakageMasterModel.pK_PackageId ? true : false,
      "packageGroup": this.pakageMasterModel.packageGroup,
      "packageType": this.pakageMasterModel.packageType,
      "Fk_SpecialityIdModule": this.authservice.Loggeduser.specialityId,
      "Fk_BranchID": null
    }
    var detailsarraydata = [];
    this.mainServiceTableData.forEach((item, index) => {
      // if (!item.pK_PackageDetailId) {
      detailsarraydata.push({
        "pK_PackageDetailId": item.pK_PackageDetailId ? item.pK_PackageDetailId : 0,
        "fK_PackageId": item.fK_PackageId ? item.fK_PackageId : 0,
        "fK_ServiceId": item.fK_ServiceId ? item.fK_ServiceId : item.serviceId,
        "rateGeneral": item.rateGeneral,
        "rateSemiPrivate": item.rateSemiPrivate,
        "ratePrivate": item.ratePrivate,
        "rateSemiDelux": item.rateSemiDelux,
        "rateDelux": item.rateDelux,
        "discount": item.discount,
        "serviceCharge": item.serviceCharge,
        "isActive": item.isActive == null ? false : true,
        "isEdit": item.pK_PackageDetailId ? true : false,
        "headName": 'PACKAGEDETAIL', //without headname Api give 500 error
        "deptName": item.deptName,
        "categoryName": item.categoryName,
        "fk_DeptId": item.fk_DeptId ? item.fk_DeptId : item.deptId,
        "fk_CategoryId": item.fk_CategoryId ? item.fk_CategoryId : item.categoryId,
        "isSCApplicable": item.isSCApplicable,
        "maxDiscountLimit": item.maxDiscountLimit,
        "isDelete": item.IsDelete ? true : false
      })
      // }
    })
    let payload = {
      PackageMaster: storepackageMaster,
      PackageDetail: detailsarraydata.concat(this.deleteArray),
      PackagePartyRelation: this.storePartyRelation
    };
    this.branchmasterService.insertPackageMaster(payload).pipe(takeUntil(this.destroypakage$)).subscribe((x: any) => {
      if (x['statusCode'] == 10) {
        this.dashboardService.openSnackBar("This record is already exists", "OK");
        this.clearFields();
      }
      if (x['statusCode'] == 1) {
        this.pakageId = x['id'];
        this.getPackagePartyRelation(this.pakageId);
        // this.getServiceList(this.pakageId);
        this.branchmasterService.getServiceList(this.pakageId).pipe(takeUntil(this.destroypakage$)).subscribe((res) => {
        }, err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        })
        this.getSearchPackageMaster(this.searchvalue);
        this.dashboardService.openSnackBar(storepackageMaster.pK_PackageId == 0 ? "Record Saved Successfully" : "Record Updated Successfully", "OK");
        if (this.addWithoutClearField == false) {
          this.storePartyRelation = [];
        }
        this.clearFields();
        this.enabledisablebtn = true;
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  clearFields() {
    if (this.addWithoutClearField) {
      this.pakageMasterModel.packageName = "";
      this.pakageMasterModel.pK_PackageId = 0;
      this.pakageMasterModel.validFrom = new Date();
      this.pakageMasterModel.validupto = new Date();
    } else {
      this.pakageMasterModel.packageName = "";
      this.pakageMasterModel.pK_PackageId = 0;
      this.pakageMasterModel.packageCodeNo = "";
      this.pakageMasterModel.packageAmount = 0;
      this.pakageMasterModel.isGlobal = true;
      this.pakageMasterModel.isActive = false;
      this.pakageMasterModel.packageGroup = "";
      this.pakageMasterModel.packageType = "";
      this.pakageMasterModel.validFrom = new Date();
      this.pakageMasterModel.validupto = new Date();
      this.filteredArray.forEach(item => { item.isSelected = false });
      this.mainServiceTableData = [];

    }
  }

  cleardata() {
    this.pakageMasterModel.packageName = ""
    this.pakageMasterModel.pK_PackageId = 0
    this.pakageMasterModel.packageCodeNo = ""
    this.pakageMasterModel.packageAmount = 0
    this.pakageMasterModel.isGlobal = true;
    this.pakageMasterModel.isActive = false
    this.pakageMasterModel.packageGroup = ""
    this.pakageMasterModel.packageType = ""
    this.mainServiceTableData = [];
    this.pakageMasterModel.validFrom = new Date();
    this.pakageMasterModel.validupto = new Date();
    this.filteredArray.forEach(item => { item.isSelected = false });
    this.isAddCase = true;
    this.enabledisablebtn = true;
    this.storePartyRelation = [];
    this.addWithoutClearField = false
  }

  exportexcel(): void {
    this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById('content');
    this.exportdata.Newexportxcel(element, 'Package-master List');

  }

  servicelistpopup() {
    const dialogRef = this.dialog.open(InvestigationServicesComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '100vw !important',
      maxHeight: '90%',
      width: '80%',
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroypakage$)).subscribe(result => {
      if (result && Array.isArray(result)) {
        this.addServicedata = result;
        // Concatenate the new data and remove duplicates
        const combinedData = this.mainServiceTableData.concat(this.addServicedata);
        this.mainServiceTableData = combinedData.reduce((unique, o) => {
          if (!unique.some(obj => obj.serviceName === o.serviceName && obj.FK_ServiceId === o.FK_ServiceId)) {
            unique.push(o);
          }
          return unique;
        }, []);

        if (result.length > 0) {
          result.forEach((element, index) => {
            const isDuplicate = this.mainServiceTableData.some(
              (item) => item.fK_ServiceId == element.serviceId
            );
            if (isDuplicate) {
              return;
            }
          });
        }
      }
    });
  }



  //Search Record Modal
  packageMasterSearchRecordModal() {
    this.searchText = '';
    this.getSearchPackageMaster(0);
    document.getElementById("packageMasterSearchRecordModal").style.display = "block";
  }
  closePackageMasterSearchRecordModal() {
    document.getElementById("packageMasterSearchRecordModal").style.display = "none";
  }

  //Package Relation Modal
  packageRelationModal() {
    if (this.pakageMasterModel.isGlobal == false) {
      document.getElementById("packageRelationModal").style.display = "block";
      this.getpartyList();
    } else {
      this.dashboardService.openSnackBar("Please Select For Specific Party", "OK");
    }
  }
  closePackageRelationModal() {
    document.getElementById("packageRelationModal").style.display = "none";
    this.searchText = null;
  }

  //Package Manager Modal
  packageManagerModal() {
    document.getElementById("packageManagerModal").style.display = "block";

  }
  closePackageManagerModal() {
    document.getElementById("packageManagerModal").style.display = "none";
  }

  ngOnDestroy() {
    this.destroypakage$.next(true);
    this.destroypakage$.unsubscribe();
    this.partylist = null;
    this.filteredArray = null;
    this.filteredserviceArray = null;
    this.serviceList = null;
    this.mainServiceTableData = null;
    this.pakageMasterModel = null;
    this.searchText = null;
    this.searchservicelist = null;
    this.filteredSearchserviceArray = null;
    this.enabledisablebtn = null;
    this.partyListArray = null;
    this.addServicedata = null;
    this.storesPackageDetails = null;
    this.storePartyRelation = null;
  }

}
